import Icon from '../components/Icon.vue'

Icon.register({
  subscript: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M395.2 416C398.7 405.5 414 394.7 431.5 383.6 448.1 373 466.9 360.9 481.8 344.7 499.3 325.7 507.7 304.5 507.7 280.1 507.7 219.6 457 192 409.9 192 367.4 192 333.6 214 315.5 242.4 310.9 249.8 312.9 259.5 320.1 264.3L350.5 284.6C357.5 289.3 366.9 287.7 372.1 281 380.1 270.6 390.9 262.8 403.8 262.8 423.1 262.8 430 275.7 430 286.7 430 322.9 310.6 343.7 310.6 446.7 310.6 453.4 311.1 459.8 312 466.1 313.1 474 319.8 480 327.9 480H496C504.8 480 512 472.8 512 464V432C512 423.2 504.8 416 496 416H395.2zM272 256C280.8 256 288 263.2 288 272V304C288 312.8 280.8 320 272 320H209.6A16-16 0 0 0 196.1 312.5L150.4 239.9C148.1 236.6 145.9 232.9 144.2 229.7 142.5 232.9 140.5 236.6 138.3 240.3L93.6 312.4A16-16 0 0 0 80 320H16C7.2 320 0 312.8 0 304V272C0 263.2 7.2 256 16 256H42.3L98.9 173.3 46.1 96H16C7.2 96 0 88.8 0 80V48C0 39.2 7.2 32 16 32H84.8A16-16 0 0 0 98.5 39.6L138.3 104.8C140.4 108.3 142.4 111.9 144.1 115.1 145.8 111.9 148 108.2 150.3 104.6L190.6 39.6A16-16 0 0 0 204.2 32H272C280.8 32 288 39.2 288 48V80C288 88.8 280.8 96 272 96H244L191.3 171.7 250 256H272z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/subscript.js
// module id = z47l
// module chunks = 144